module.exports = __webpack_public_path__ + "static/media/ic_check_circle.93eee9e3.svg";